import {
  AfterViewInit,
  Directive,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MapsGeocodingService } from '@map/services/maps-geocoding/maps-geocoding.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MapNetFilterType } from '../../../../../shared/enums/map-filter-enum';

@UntilDestroy()
@Directive({
  selector: 'app-map-zip-area',
})
export class MapZipAreaDirective implements OnChanges, AfterViewInit {
  public readonly mapNetFilterTypes = MapNetFilterType;
  @Input({ required: true })
  public map: google.maps.Map;
  @Input({ required: true })
  public zipCode: string;
  @Input({ required: true })
  public activeNetTypes: number[];

  constructor(private readonly mapsGeocodingService: MapsGeocodingService) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes['activeNetTypes']) {
      if (!this.activeNetTypes.includes(this.mapNetFilterTypes.AREA)) {
        this.mapsGeocodingService.makeFeatureLayerTransparent();
      } else {
        this.mapsGeocodingService.setFeatureLayerStyle();
      }
    }
  }

  public async ngAfterViewInit(): Promise<void> {
    if (this.activeNetTypes.includes(this.mapNetFilterTypes.AREA)) {
      await this.mapsGeocodingService.drawZipCodeArea(this.map, this.zipCode);
    }
  }
}
